// extracted by mini-css-extract-plugin
module.exports = {"tile":"suggested-price-icon-tile_tile__QwuTQ"};